const Mail03 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}>
    <path
      fill="currentColor"
      d="M8.9689 11c-.3601 0-.5402 0-.7143-.031a2.0028 2.0028 0 0 1-.4492-.136c-.162-.0708-.312-.1707-.6116-.3704L2 7c0-1.6569 1.3432-3 3-3h14c1.6569 0 3 1.3431 3 3l-5.1938 3.4626c-.2997.1997-.4495.2996-.6116.3704a2.0027 2.0027 0 0 1-.4492.136c-.1741.031-.3542.031-.7143.031H8.9689Z"
      opacity={0.12}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m2 7 5.1938 3.4626c.2997.1997.4495.2996.6116.3704.1439.0628.2946.1084.4492.136.174.031.3542.031.7143.031h6.0622c.3601 0 .5402 0 .7143-.031a2.0027 2.0027 0 0 0 .4492-.136c.1621-.0708.3119-.1707.6116-.3704L22 7M6.8 20h10.4c1.6802 0 2.5202 0 3.162-.327a2.9994 2.9994 0 0 0 1.311-1.311C22 17.7202 22 16.8802 22 15.2V8.8c0-1.6802 0-2.5202-.327-3.162a2.9997 2.9997 0 0 0-1.311-1.311C19.7202 4 18.8802 4 17.2 4H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.2798 2 7.1198 2 8.8v6.4c0 1.6802 0 2.5202.327 3.162a2.9997 2.9997 0 0 0 1.311 1.311C4.2798 20 5.1198 20 6.8 20Z"
    />
  </svg>
);

export default Mail03;
